export default "<script type=\"text/x-mustache-template\"></script>";